export default __webpack_public_path__ + "static/media/1-2.5589ba33.jpg";